import { render } from "./CategoryButtons.vue?vue&type=template&id=65719d20&scoped=true"
import script from "./CategoryButtons.vue?vue&type=script&lang=js"
export * from "./CategoryButtons.vue?vue&type=script&lang=js"

import "./CategoryButtons.vue?vue&type=style&index=0&id=65719d20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65719d20"]])

export default __exports__